export const ClienteRouteNames = {
  // Secciones nuevo diseño Material de apoyo
    //Bienvenida
  materialApoyoBienvenida: "cliente-cliente-material-apoyo-bienvenida",
  materialApoyoEstrena2: "cliente-cliente-material-apoyo-estrena2",
  materialApoyoHazteDuena: "cliente-cliente-material-apoyo-hazte-duena",
  materialApoyoTuConstruye: "cliente-cliente-material-apoyo-tu-construye",
  materialApoyoPreventa: "cliente-cliente-material-apoyo-preventa",
    // Pagos
  materialApoyoPagos: "cliente-cliente-material-apoyo-pagos",
  // materialApoyoDescuentos
  // materialApoyoDomiciliacion
    // Seguros
  materialApoyoSeguros: "cliente-cliente-material-apoyo-seguros",
    // Tramites
  materialApoyoGuiaTramites: "cliente-cliente-material-apoyo-guia-tramites",
  // materialApoyoDePagos:
  // materialApoyoDeContratos:
  // materialApoyoAclaraciones:
    // Adjudicacion
  materialApoyoGuiaDeAdjudicacion: "cliente-cliente-material-apoyo-adjudicacion",
    // Analisis financiero
  // materialApoyoEntrevista
  materialApoyoAvaluos: "cliente-cliente-material-apoyo-avaluos",
  materialApoyoFirmaEscrituras: "cliente-cliente-material-apoyo-firma",
    // Escrituracion TODO: agregar aqui la ruta correcta de cada seccion
  materialApoyoLiquidacionDeHipoteca:"cliente-cliente-material-apoyo-liquidacion",
  materialApoyoLiberacionCancelacion:"cliente-cliente-material-apoyo-liberacion"
} as const

export type ClienteRouteName = typeof ClienteRouteNames[keyof typeof ClienteRouteNames]
